import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, handleErr } from "../lib/api";
import { useAuth } from "./AuthContext";

const Ctx = createContext(null);

export function BrandProvider({ children }) {
  const { user, refresh } = useAuth();
  const [brands, setBrands] = useState([]);
  const reload = useCallback(() => api.get("/brands").then((r) => setBrands(r.data)), []);
  useEffect(() => { reload(); }, [reload]);
  const active = brands.find((b) => b.brandId === user?.activeBrandId) || brands[0] || null;

  const switchTo = async (brandId) => {
    try {
      await api.put("/brands/active", { brandId });
      await refresh();
      toast.success(`Switched to ${brands.find((b) => b.brandId === brandId)?.businessName}`);
    } catch (e) { handleErr(e); }
  };
  const create = async (form) => {
    const { data } = await api.post("/brands", form);
    await Promise.all([reload(), refresh()]);
    return data;
  };
  const remove = async (brandId) => {
    await api.delete(`/brands/${brandId}`);
    await Promise.all([reload(), refresh()]);
  };

  return <Ctx.Provider value={{ brands, active, reload, switchTo, create, remove }}>{children}</Ctx.Provider>;
}

export const useBrands = () => useContext(Ctx);
